import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'
import { TEST_ID } from '@/src/general/constants/testId'

export const ConversationPreviewPlaceholder = (): ReactNode => (
  <Placeholder
    testID={TEST_ID.CONVERSATION.PREVIEW.ITEM_PLACEHOLDER}
    className="flex max-w-full flex-row gap-2 px-2 py-2"
  >
    <PlaceholderMedia size="avatar-md" />
    <View className="flex-1 flex-col place-content-between gap-1">
      <PlaceholderLine className="max-w-40" size="md" radius="full" />
      <PlaceholderLine className="mr-4 min-h-5 max-w-[95%] flex-1" size="sm" radius="full" />
    </View>
  </Placeholder>
)
